/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format, fromUnixTime } from 'date-fns';

const Time = (props) => {
  const { value,timelineType } = props;
  const [timeFormatted, setTimeFormatted] = useState(value);

  useEffect(() => {
    if (value !== '') {
      
      if(timelineType=="currentEpoch"){
        if (value !== '' && parseInt(value, 10) > 1) {
          const dateType = fromUnixTime(value) == "Invalid Date" ? new Date(value/1000) : fromUnixTime(value/1000);
          setTimeFormatted(format(dateType, 'dd/MM/yyyy, H:mma'));
        }else if(value==0)
          setTimeFormatted('');
      }
      else if(timelineType=="videoProgressRelative"){
        let v=value/1000;
        let min= v/60;
        let seg= v % 60;
        let hour=0;
        if(min>60){
          hour=Math.floor(Math.floor(min)/60);
          min=Math.floor(min % 60);
        }
        setTimeFormatted(Math.floor(hour).toString().padStart(2,0)+":"+Math.floor(min).toString().padStart(2,0)+":"+Math.floor(seg).toString().padStart(2,0));
      }else{
        setTimeFormatted('');
      }
      
    }else if(value==0)
      setTimeFormatted('');
  }, [value]);

  return (
    <div>
      {timeFormatted}
    </div>
  );
};

Time.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

Time.defaultProps = {
  value: '',
};

export default Time;
